module.exports = __webpack_public_path__ + "img/fly-cool-internet.a5421c5f.png";